import * as React from "react";
import { forwardRef } from "react";
const SvgBar = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 10 10" ref={ref} {...props}><path d="M2.637 9.384V7.647H.32v1.737zM6.11 5.91V4.173H.32V5.91zM9.006 2.435V.698H.32v1.737z" /></svg>;
const ForwardRef = forwardRef(SvgBar);
export default ForwardRef;